import ListingTypeEnum from '@models/enums/ListingTypeEnum';
import { IListing, IListingFilterItem } from '@models/IListing';
import ListingWrapper from '@molecules/ListingWrapper/ListingWrapper';

interface Props extends IListing {
  readonly autoCompleteEndpoint: string;
  readonly colourFilters: IListingFilterItem[];
  readonly pageUrl: string;
}

const ColourListing = ({ colourFilters, ...props }: Props) => {
  const initialColourQueryParams = {
    paletteIds: [],
  };

  return (
    <ListingWrapper
      {...props}
      additionalFilters={['relatedProductIds']}
      listingFilterParam="paletteIds"
      listingFilters={colourFilters}
      customQueryParams={initialColourQueryParams}
      type={ListingTypeEnum.Colour}
    />
  );
};

export default ColourListing;
